import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SpaceListItem } from './useAdminSpaces';

export function useSpacesFilters(spaces: SpaceListItem[]) {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const filterStatus = searchParams.get('status') ?? 'ALL';
  const filterWorkflow = searchParams.get('workflow') ?? 'ALL';
  const hasActiveFilters = filterStatus !== 'ALL' || filterWorkflow !== 'ALL';

  const filteredSpaces = useMemo(() => {
    return spaces.filter((space) => {
      // 1. Filter by Status
      if (filterStatus === 'ACTIVE' && !space.isActive) return false;
      if (filterStatus === 'INACTIVE' && space.isActive) return false;

      // 2. Filter by Workflow
      if (filterWorkflow !== 'ALL' && space.workflow !== filterWorkflow) return false;

      return true;
    });
  }, [spaces, filterStatus, filterWorkflow]);

  const resetFilters = () => setSearchParams({});

  const setStatusFilter = (v: string) => {
    setSearchParams((prev) => {
      if (v === 'ALL') prev.delete('status');
      else prev.set('status', v);
      return prev;
    });
  };

  const setWorkflowFilter = (v: string) => {
    setSearchParams((prev) => {
      if (v === 'ALL') prev.delete('workflow');
      else prev.set('workflow', v);
      return prev;
    });
  };

  return {
    filterStatus,
    filterWorkflow,
    hasActiveFilters,
    filteredSpaces,
    resetFilters,
    setStatusFilter,
    setWorkflowFilter,
  };
}
